[
    {
        "BGT": "G",
        "CBS": 3,
        "Naam": "Appingedam",
        "BGTcode": "G0003"
    },
    {
        "BGT": "G",
        "CBS": 5,
        "Naam": "Bedum",
        "BGTcode": "G0005"
    },
    {
        "BGT": "G",
        "CBS": 7,
        "Naam": "Bellingwedde",
        "BGTcode": "G0007"
    },
    {
        "BGT": "G",
        "CBS": 9,
        "Naam": "Ten Boer",
        "BGTcode": "G0009"
    },
    {
        "BGT": "G",
        "CBS": 10,
        "Naam": "Delfzijl",
        "BGTcode": "G0010"
    },
    {
        "BGT": "G",
        "CBS": 14,
        "Naam": "Groningen",
        "BGTcode": "G0014"
    },
    {
        "BGT": "G",
        "CBS": 15,
        "Naam": "Grootegast",
        "BGTcode": "G0015"
    },
    {
        "BGT": "G",
        "CBS": 17,
        "Naam": "Haren",
        "BGTcode": "G0017"
    },
    {
        "BGT": "G",
        "CBS": 18,
        "Naam": "Hoogezand-Sappemeer",
        "BGTcode": "G0018"
    },
    {
        "BGT": "G",
        "CBS": 22,
        "Naam": "Leek",
        "BGTcode": "G0022"
    },
    {
        "BGT": "G",
        "CBS": 24,
        "Naam": "Loppersum",
        "BGTcode": "G0024"
    },
    {
        "BGT": "G",
        "CBS": 25,
        "Naam": "Marum",
        "BGTcode": "G0025"
    },
    {
        "BGT": "G",
        "CBS": 34,
        "Naam": "Almere",
        "BGTcode": "G0034"
    },
    {
        "BGT": "G",
        "CBS": 37,
        "Naam": "Stadskanaal",
        "BGTcode": "G0037"
    },
    {
        "BGT": "G",
        "CBS": 40,
        "Naam": "Slochteren",
        "BGTcode": "G0040"
    },
    {
        "BGT": "G",
        "CBS": 47,
        "Naam": "Veendam",
        "BGTcode": "G0047"
    },
    {
        "BGT": "G",
        "CBS": 48,
        "Naam": "Vlagtwedde",
        "BGTcode": "G0048"
    },
    {
        "BGT": "G",
        "CBS": 50,
        "Naam": "Zeewolde",
        "BGTcode": "G0050"
    },
    {
        "BGT": "G",
        "CBS": 51,
        "Naam": "Skarsterlân",
        "BGTcode": "G0051"
    },
    {
        "BGT": "G",
        "CBS": 53,
        "Naam": "Winsum",
        "BGTcode": "G0053"
    },
    {
        "BGT": "G",
        "CBS": 55,
        "Naam": "Boarnsterhim",
        "BGTcode": "G0055"
    },
    {
        "BGT": "G",
        "CBS": 56,
        "Naam": "Zuidhorn",
        "BGTcode": "G0056"
    },
    {
        "BGT": "G",
        "CBS": 58,
        "Naam": "Dongeradeel",
        "BGTcode": "G0058"
    },
    {
        "BGT": "G",
        "CBS": 59,
        "Naam": "Achtkarspelen",
        "BGTcode": "G0059"
    },
    {
        "BGT": "G",
        "CBS": 60,
        "Naam": "Ameland",
        "BGTcode": "G0060"
    },
    {
        "BGT": "G",
        "CBS": 63,
        "Naam": "het Bildt",
        "BGTcode": "G0063"
    },
    {
        "BGT": "G",
        "CBS": 70,
        "Naam": "Franekeradeel",
        "BGTcode": "G0070"
    },
    {
        "BGT": "G",
        "CBS": 72,
        "Naam": "Harlingen",
        "BGTcode": "G0072"
    },
    {
        "BGT": "G",
        "CBS": 74,
        "Naam": "Heerenveen",
        "BGTcode": "G0074"
    },
    {
        "BGT": "G",
        "CBS": 79,
        "Naam": "Kollumerland en Nieuwkruisland",
        "BGTcode": "G0079"
    },
    {
        "BGT": "G",
        "CBS": 80,
        "Naam": "Leeuwarden",
        "BGTcode": "G0080"
    },
    {
        "BGT": "G",
        "CBS": 81,
        "Naam": "Leeuwarderadeel",
        "BGTcode": "G0081"
    },
    {
        "BGT": "G",
        "CBS": 82,
        "Naam": "Lemsterland",
        "BGTcode": "G0082"
    },
    {
        "BGT": "G",
        "CBS": 85,
        "Naam": "Ooststellingwerf",
        "BGTcode": "G0085"
    },
    {
        "BGT": "G",
        "CBS": 86,
        "Naam": "Opsterland",
        "BGTcode": "G0086"
    },
    {
        "BGT": "G",
        "CBS": 88,
        "Naam": "Schiermonnikoog",
        "BGTcode": "G0088"
    },
    {
        "BGT": "G",
        "CBS": 90,
        "Naam": "Smallingerland",
        "BGTcode": "G0090"
    },
    {
        "BGT": "G",
        "CBS": 93,
        "Naam": "Terschelling",
        "BGTcode": "G0093"
    },
    {
        "BGT": "G",
        "CBS": 96,
        "Naam": "Vlieland",
        "BGTcode": "G0096"
    },
    {
        "BGT": "G",
        "CBS": 98,
        "Naam": "Weststellingwerf",
        "BGTcode": "G0098"
    },
    {
        "BGT": "G",
        "CBS": 106,
        "Naam": "Assen",
        "BGTcode": "G0106"
    },
    {
        "BGT": "G",
        "CBS": 109,
        "Naam": "Coevorden",
        "BGTcode": "G0109"
    },
    {
        "BGT": "G",
        "CBS": 114,
        "Naam": "Emmen",
        "BGTcode": "G0114"
    },
    {
        "BGT": "G",
        "CBS": 118,
        "Naam": "Hoogeveen",
        "BGTcode": "G0118"
    },
    {
        "BGT": "G",
        "CBS": 119,
        "Naam": "Meppel",
        "BGTcode": "G0119"
    },
    {
        "BGT": "G",
        "CBS": 140,
        "Naam": "Littenseradiel",
        "BGTcode": "G0140"
    },
    {
        "BGT": "G",
        "CBS": 141,
        "Naam": "Almelo",
        "BGTcode": "G0141"
    },
    {
        "BGT": "G",
        "CBS": 147,
        "Naam": "Borne",
        "BGTcode": "G0147"
    },
    {
        "BGT": "G",
        "CBS": 148,
        "Naam": "Dalfsen",
        "BGTcode": "G0148"
    },
    {
        "BGT": "G",
        "CBS": 150,
        "Naam": "Deventer",
        "BGTcode": "G0150"
    },
    {
        "BGT": "G",
        "CBS": 153,
        "Naam": "Enschede",
        "BGTcode": "G0153"
    },
    {
        "BGT": "G",
        "CBS": 158,
        "Naam": "Haaksbergen",
        "BGTcode": "G0158"
    },
    {
        "BGT": "G",
        "CBS": 160,
        "Naam": "Hardenberg",
        "BGTcode": "G0160"
    },
    {
        "BGT": "G",
        "CBS": 163,
        "Naam": "Hellendoorn",
        "BGTcode": "G0163"
    },
    {
        "BGT": "G",
        "CBS": 164,
        "Naam": "Hengelo",
        "BGTcode": "G0164"
    },
    {
        "BGT": "G",
        "CBS": 166,
        "Naam": "Kampen",
        "BGTcode": "G0166"
    },
    {
        "BGT": "G",
        "CBS": 168,
        "Naam": "Losser",
        "BGTcode": "G0168"
    },
    {
        "BGT": "G",
        "CBS": 171,
        "Naam": "Noordoostpolder",
        "BGTcode": "G0171"
    },
    {
        "BGT": "G",
        "CBS": 173,
        "Naam": "Oldenzaal",
        "BGTcode": "G0173"
    },
    {
        "BGT": "G",
        "CBS": 175,
        "Naam": "Ommen",
        "BGTcode": "G0175"
    },
    {
        "BGT": "G",
        "CBS": 177,
        "Naam": "Raalte",
        "BGTcode": "G0177"
    },
    {
        "BGT": "G",
        "CBS": 180,
        "Naam": "Staphorst",
        "BGTcode": "G0180"
    },
    {
        "BGT": "G",
        "CBS": 183,
        "Naam": "Tubbergen",
        "BGTcode": "G0183"
    },
    {
        "BGT": "G",
        "CBS": 184,
        "Naam": "Urk",
        "BGTcode": "G0184"
    },
    {
        "BGT": "G",
        "CBS": 189,
        "Naam": "Wierden",
        "BGTcode": "G0189"
    },
    {
        "BGT": "G",
        "CBS": 193,
        "Naam": "Zwolle",
        "BGTcode": "G0193"
    },
    {
        "BGT": "G",
        "CBS": 196,
        "Naam": "Rijnwaarden",
        "BGTcode": "G0196"
    },
    {
        "BGT": "G",
        "CBS": 197,
        "Naam": "Aalten",
        "BGTcode": "G0197"
    },
    {
        "BGT": "G",
        "CBS": 1924,
        "Naam": "Goeree-Overflakkee",
        "BGTcode": "G1924"
    },
    {
        "BGT": "G",
        "CBS": 1927,
        "Naam": "Molenwaard",
        "BGTcode": "G1927"
    },
    {
        "BGT": "G",
        "CBS": 200,
        "Naam": "Apeldoorn",
        "BGTcode": "G0200"
    },
    {
        "BGT": "G",
        "CBS": 202,
        "Naam": "Arnhem",
        "BGTcode": "G0202"
    },
    {
        "BGT": "G",
        "CBS": 203,
        "Naam": "Barneveld",
        "BGTcode": "G0203"
    },
    {
        "BGT": "G",
        "CBS": 209,
        "Naam": "Beuningen",
        "BGTcode": "G0209"
    },
    {
        "BGT": "G",
        "CBS": 213,
        "Naam": "Brummen",
        "BGTcode": "G0213"
    },
    {
        "BGT": "G",
        "CBS": 214,
        "Naam": "Buren",
        "BGTcode": "G0214"
    },
    {
        "BGT": "G",
        "CBS": 216,
        "Naam": "Culemborg",
        "BGTcode": "G0216"
    },
    {
        "BGT": "G",
        "CBS": 221,
        "Naam": "Doesburg",
        "BGTcode": "G0221"
    },
    {
        "BGT": "G",
        "CBS": 222,
        "Naam": "Doetinchem",
        "BGTcode": "G0222"
    },
    {
        "BGT": "G",
        "CBS": 225,
        "Naam": "Druten",
        "BGTcode": "G0225"
    },
    {
        "BGT": "G",
        "CBS": 226,
        "Naam": "Duiven",
        "BGTcode": "G0226"
    },
    {
        "BGT": "G",
        "CBS": 228,
        "Naam": "Ede",
        "BGTcode": "G0228"
    },
    {
        "BGT": "G",
        "CBS": 230,
        "Naam": "Elburg",
        "BGTcode": "G0230"
    },
    {
        "BGT": "G",
        "CBS": 232,
        "Naam": "Epe",
        "BGTcode": "G0232"
    },
    {
        "BGT": "G",
        "CBS": 233,
        "Naam": "Ermelo",
        "BGTcode": "G0233"
    },
    {
        "BGT": "G",
        "CBS": 236,
        "Naam": "Geldermalsen",
        "BGTcode": "G0236"
    },
    {
        "BGT": "G",
        "CBS": 241,
        "Naam": "Groesbeek",
        "BGTcode": "G0241"
    },
    {
        "BGT": "G",
        "CBS": 243,
        "Naam": "Harderwijk",
        "BGTcode": "G0243"
    },
    {
        "BGT": "G",
        "CBS": 244,
        "Naam": "Hattem",
        "BGTcode": "G0244"
    },
    {
        "BGT": "G",
        "CBS": 246,
        "Naam": "Heerde",
        "BGTcode": "G0246"
    },
    {
        "BGT": "G",
        "CBS": 252,
        "Naam": "Heumen",
        "BGTcode": "G0252"
    },
    {
        "BGT": "G",
        "CBS": 262,
        "Naam": "Lochem",
        "BGTcode": "G0262"
    },
    {
        "BGT": "G",
        "CBS": 263,
        "Naam": "Maasdriel",
        "BGTcode": "G0263"
    },
    {
        "BGT": "G",
        "CBS": 265,
        "Naam": "Millingen aan de Rijn",
        "BGTcode": "G0265"
    },
    {
        "BGT": "G",
        "CBS": 267,
        "Naam": "Nijkerk",
        "BGTcode": "G0267"
    },
    {
        "BGT": "G",
        "CBS": 268,
        "Naam": "Nijmegen",
        "BGTcode": "G0268"
    },
    {
        "BGT": "G",
        "CBS": 269,
        "Naam": "Oldebroek",
        "BGTcode": "G0269"
    },
    {
        "BGT": "G",
        "CBS": 273,
        "Naam": "Putten",
        "BGTcode": "G0273"
    },
    {
        "BGT": "G",
        "CBS": 274,
        "Naam": "Renkum",
        "BGTcode": "G0274"
    },
    {
        "BGT": "G",
        "CBS": 275,
        "Naam": "Rheden",
        "BGTcode": "G0275"
    },
    {
        "BGT": "G",
        "CBS": 277,
        "Naam": "Rozendaal",
        "BGTcode": "G0277"
    },
    {
        "BGT": "G",
        "CBS": 279,
        "Naam": "Scherpenzeel",
        "BGTcode": "G0279"
    },
    {
        "BGT": "G",
        "CBS": 281,
        "Naam": "Tiel",
        "BGTcode": "G0281"
    },
    {
        "BGT": "G",
        "CBS": 282,
        "Naam": "Ubbergen",
        "BGTcode": "G0282"
    },
    {
        "BGT": "G",
        "CBS": 285,
        "Naam": "Voorst",
        "BGTcode": "G0285"
    },
    {
        "BGT": "G",
        "CBS": 289,
        "Naam": "Wageningen",
        "BGTcode": "G0289"
    },
    {
        "BGT": "G",
        "CBS": 293,
        "Naam": "Westervoort",
        "BGTcode": "G0293"
    },
    {
        "BGT": "G",
        "CBS": 294,
        "Naam": "Winterswijk",
        "BGTcode": "G0294"
    },
    {
        "BGT": "G",
        "CBS": 296,
        "Naam": "Wijchen",
        "BGTcode": "G0296"
    },
    {
        "BGT": "G",
        "CBS": 297,
        "Naam": "Zaltbommel",
        "BGTcode": "G0297"
    },
    {
        "BGT": "G",
        "CBS": 299,
        "Naam": "Zevenaar",
        "BGTcode": "G0299"
    },
    {
        "BGT": "G",
        "CBS": 301,
        "Naam": "Zutphen",
        "BGTcode": "G0301"
    },
    {
        "BGT": "G",
        "CBS": 302,
        "Naam": "Nunspeet",
        "BGTcode": "G0302"
    },
    {
        "BGT": "G",
        "CBS": 303,
        "Naam": "Dronten",
        "BGTcode": "G0303"
    },
    {
        "BGT": "G",
        "CBS": 304,
        "Naam": "Neerijnen",
        "BGTcode": "G0304"
    },
    {
        "BGT": "G",
        "CBS": 307,
        "Naam": "Amersfoort",
        "BGTcode": "G0307"
    },
    {
        "BGT": "G",
        "CBS": 308,
        "Naam": "Baarn",
        "BGTcode": "G0308"
    },
    {
        "BGT": "G",
        "CBS": 310,
        "Naam": "De Bilt",
        "BGTcode": "G0310"
    },
    {
        "BGT": "G",
        "CBS": 312,
        "Naam": "Bunnik",
        "BGTcode": "G0312"
    },
    {
        "BGT": "G",
        "CBS": 313,
        "Naam": "Bunschoten",
        "BGTcode": "G0313"
    },
    {
        "BGT": "G",
        "CBS": 317,
        "Naam": "Eemnes",
        "BGTcode": "G0317"
    },
    {
        "BGT": "G",
        "CBS": 321,
        "Naam": "Houten",
        "BGTcode": "G0321"
    },
    {
        "BGT": "G",
        "CBS": 327,
        "Naam": "Leusden",
        "BGTcode": "G0327"
    },
    {
        "BGT": "G",
        "CBS": 331,
        "Naam": "Lopik",
        "BGTcode": "G0331"
    },
    {
        "BGT": "G",
        "CBS": 335,
        "Naam": "Montfoort",
        "BGTcode": "G0335"
    },
    {
        "BGT": "G",
        "CBS": 339,
        "Naam": "Renswoude",
        "BGTcode": "G0339"
    },
    {
        "BGT": "G",
        "CBS": 340,
        "Naam": "Rhenen",
        "BGTcode": "G0340"
    },
    {
        "BGT": "G",
        "CBS": 342,
        "Naam": "Soest",
        "BGTcode": "G0342"
    },
    {
        "BGT": "G",
        "CBS": 344,
        "Naam": "Utrecht",
        "BGTcode": "G0344"
    },
    {
        "BGT": "G",
        "CBS": 345,
        "Naam": "Veenendaal",
        "BGTcode": "G0345"
    },
    {
        "BGT": "G",
        "CBS": 351,
        "Naam": "Woudenberg",
        "BGTcode": "G0351"
    },
    {
        "BGT": "G",
        "CBS": 352,
        "Naam": "Wijk bij Duurstede",
        "BGTcode": "G0352"
    },
    {
        "BGT": "G",
        "CBS": 353,
        "Naam": "IJsselstein",
        "BGTcode": "G0353"
    },
    {
        "BGT": "G",
        "CBS": 355,
        "Naam": "Zeist",
        "BGTcode": "G0355"
    },
    {
        "BGT": "G",
        "CBS": 356,
        "Naam": "Nieuwegein",
        "BGTcode": "G0356"
    },
    {
        "BGT": "G",
        "CBS": 358,
        "Naam": "Aalsmeer",
        "BGTcode": "G0358"
    },
    {
        "BGT": "G",
        "CBS": 361,
        "Naam": "Alkmaar",
        "BGTcode": "G0361"
    },
    {
        "BGT": "G",
        "CBS": 362,
        "Naam": "Amstelveen",
        "BGTcode": "G0362"
    },
    {
        "BGT": "G",
        "CBS": 363,
        "Naam": "Amsterdam",
        "BGTcode": "G0363"
    },
    {
        "BGT": "G",
        "CBS": 365,
        "Naam": "Graft-De Rijp",
        "BGTcode": "G0365"
    },
    {
        "BGT": "G",
        "CBS": 370,
        "Naam": "Beemster",
        "BGTcode": "G0370"
    },
    {
        "BGT": "G",
        "CBS": 373,
        "Naam": "Bergen (NH.)",
        "BGTcode": "G0373"
    },
    {
        "BGT": "G",
        "CBS": 375,
        "Naam": "Beverwijk",
        "BGTcode": "G0375"
    },
    {
        "BGT": "G",
        "CBS": 376,
        "Naam": "Blaricum",
        "BGTcode": "G0376"
    },
    {
        "BGT": "G",
        "CBS": 377,
        "Naam": "Bloemendaal",
        "BGTcode": "G0377"
    },
    {
        "BGT": "G",
        "CBS": 381,
        "Naam": "Bussum",
        "BGTcode": "G0381"
    },
    {
        "BGT": "G",
        "CBS": 383,
        "Naam": "Castricum",
        "BGTcode": "G0383"
    },
    {
        "BGT": "G",
        "CBS": 384,
        "Naam": "Diemen",
        "BGTcode": "G0384"
    },
    {
        "BGT": "G",
        "CBS": 385,
        "Naam": "Edam-Volendam",
        "BGTcode": "G0385"
    },
    {
        "BGT": "G",
        "CBS": 388,
        "Naam": "Enkhuizen",
        "BGTcode": "G0388"
    },
    {
        "BGT": "G",
        "CBS": 392,
        "Naam": "Haarlem",
        "BGTcode": "G0392"
    },
    {
        "BGT": "G",
        "CBS": 393,
        "Naam": "Haarlemmerliede en Spaarnwoude",
        "BGTcode": "G0393"
    },
    {
        "BGT": "G",
        "CBS": 394,
        "Naam": "Haarlemmermeer",
        "BGTcode": "G0394"
    },
    {
        "BGT": "G",
        "CBS": 395,
        "Naam": "Harenkarspel",
        "BGTcode": "G0395"
    },
    {
        "BGT": "G",
        "CBS": 396,
        "Naam": "Heemskerk",
        "BGTcode": "G0396"
    },
    {
        "BGT": "G",
        "CBS": 397,
        "Naam": "Heemstede",
        "BGTcode": "G0397"
    },
    {
        "BGT": "G",
        "CBS": 398,
        "Naam": "Heerhugowaard",
        "BGTcode": "G0398"
    },
    {
        "BGT": "G",
        "CBS": 399,
        "Naam": "Heiloo",
        "BGTcode": "G0399"
    },
    {
        "BGT": "G",
        "CBS": 400,
        "Naam": "Den Helder",
        "BGTcode": "G0400"
    },
    {
        "BGT": "G",
        "CBS": 402,
        "Naam": "Hilversum",
        "BGTcode": "G0402"
    },
    {
        "BGT": "G",
        "CBS": 405,
        "Naam": "Hoorn",
        "BGTcode": "G0405"
    },
    {
        "BGT": "G",
        "CBS": 406,
        "Naam": "Huizen",
        "BGTcode": "G0406"
    },
    {
        "BGT": "G",
        "CBS": 415,
        "Naam": "Landsmeer",
        "BGTcode": "G0415"
    },
    {
        "BGT": "G",
        "CBS": 416,
        "Naam": "Langedijk",
        "BGTcode": "G0416"
    },
    {
        "BGT": "G",
        "CBS": 417,
        "Naam": "Laren",
        "BGTcode": "G0417"
    },
    {
        "BGT": "G",
        "CBS": 420,
        "Naam": "Medemblik",
        "BGTcode": "G0420"
    },
    {
        "BGT": "G",
        "CBS": 424,
        "Naam": "Muiden",
        "BGTcode": "G0424"
    },
    {
        "BGT": "G",
        "CBS": 425,
        "Naam": "Naarden",
        "BGTcode": "G0425"
    },
    {
        "BGT": "G",
        "CBS": 431,
        "Naam": "Oostzaan",
        "BGTcode": "G0431"
    },
    {
        "BGT": "G",
        "CBS": 432,
        "Naam": "Opmeer",
        "BGTcode": "G0432"
    },
    {
        "BGT": "G",
        "CBS": 437,
        "Naam": "Ouder-Amstel",
        "BGTcode": "G0437"
    },
    {
        "BGT": "G",
        "CBS": 439,
        "Naam": "Purmerend",
        "BGTcode": "G0439"
    },
    {
        "BGT": "G",
        "CBS": 441,
        "Naam": "Schagen",
        "BGTcode": "G0441"
    },
    {
        "BGT": "G",
        "CBS": 448,
        "Naam": "Texel",
        "BGTcode": "G0448"
    },
    {
        "BGT": "G",
        "CBS": 450,
        "Naam": "Uitgeest",
        "BGTcode": "G0450"
    },
    {
        "BGT": "G",
        "CBS": 451,
        "Naam": "Uithoorn",
        "BGTcode": "G0451"
    },
    {
        "BGT": "G",
        "CBS": 453,
        "Naam": "Velsen",
        "BGTcode": "G0453"
    },
    {
        "BGT": "G",
        "CBS": 457,
        "Naam": "Weesp",
        "BGTcode": "G0457"
    },
    {
        "BGT": "G",
        "CBS": 458,
        "Naam": "Schermer",
        "BGTcode": "G0458"
    },
    {
        "BGT": "G",
        "CBS": 473,
        "Naam": "Zandvoort",
        "BGTcode": "G0473"
    },
    {
        "BGT": "G",
        "CBS": 476,
        "Naam": "Zijpe",
        "BGTcode": "G0476"
    },
    {
        "BGT": "G",
        "CBS": 478,
        "Naam": "Zeevang",
        "BGTcode": "G0478"
    },
    {
        "BGT": "G",
        "CBS": 479,
        "Naam": "Zaanstad",
        "BGTcode": "G0479"
    },
    {
        "BGT": "G",
        "CBS": 482,
        "Naam": "Alblasserdam",
        "BGTcode": "G0482"
    },
    {
        "BGT": "G",
        "CBS": 484,
        "Naam": "Alphen aan den Rijn",
        "BGTcode": "G0484"
    },
    {
        "BGT": "G",
        "CBS": 489,
        "Naam": "Barendrecht",
        "BGTcode": "G0489"
    },
    {
        "BGT": "G",
        "CBS": 491,
        "Naam": "Bergambacht",
        "BGTcode": "G0491"
    },
    {
        "BGT": "G",
        "CBS": 498,
        "Naam": "Drechterland",
        "BGTcode": "G0498"
    },
    {
        "BGT": "G",
        "CBS": 499,
        "Naam": "Boskoop",
        "BGTcode": "G0499"
    },
    {
        "BGT": "G",
        "CBS": 501,
        "Naam": "Brielle",
        "BGTcode": "G0501"
    },
    {
        "BGT": "G",
        "CBS": 502,
        "Naam": "Capelle aan den IJssel",
        "BGTcode": "G0502"
    },
    {
        "BGT": "G",
        "CBS": 503,
        "Naam": "Delft",
        "BGTcode": "G0503"
    },
    {
        "BGT": "G",
        "CBS": 504,
        "Naam": "Dirksland",
        "BGTcode": "G0504"
    },
    {
        "BGT": "G",
        "CBS": 505,
        "Naam": "Dordrecht",
        "BGTcode": "G0505"
    },
    {
        "BGT": "G",
        "CBS": 511,
        "Naam": "Goedereede",
        "BGTcode": "G0511"
    },
    {
        "BGT": "G",
        "CBS": 512,
        "Naam": "Gorinchem",
        "BGTcode": "G0512"
    },
    {
        "BGT": "G",
        "CBS": 513,
        "Naam": "Gouda",
        "BGTcode": "G0513"
    },
    {
        "BGT": "G",
        "CBS": 518,
        "Naam": "'s-Gravenhage",
        "BGTcode": "G0518"
    },
    {
        "BGT": "G",
        "CBS": 523,
        "Naam": "Hardinxveld-Giessendam",
        "BGTcode": "G0523"
    },
    {
        "BGT": "G",
        "CBS": 530,
        "Naam": "Hellevoetsluis",
        "BGTcode": "G0530"
    },
    {
        "BGT": "G",
        "CBS": 531,
        "Naam": "Hendrik-Ido-Ambacht",
        "BGTcode": "G0531"
    },
    {
        "BGT": "G",
        "CBS": 532,
        "Naam": "Stede Broec",
        "BGTcode": "G0532"
    },
    {
        "BGT": "G",
        "CBS": 534,
        "Naam": "Hillegom",
        "BGTcode": "G0534"
    },
    {
        "BGT": "G",
        "CBS": 537,
        "Naam": "Katwijk",
        "BGTcode": "G0537"
    },
    {
        "BGT": "G",
        "CBS": 542,
        "Naam": "Krimpen aan den IJssel",
        "BGTcode": "G0542"
    },
    {
        "BGT": "G",
        "CBS": 545,
        "Naam": "Leerdam",
        "BGTcode": "G0545"
    },
    {
        "BGT": "G",
        "CBS": 546,
        "Naam": "Leiden",
        "BGTcode": "G0546"
    },
    {
        "BGT": "G",
        "CBS": 547,
        "Naam": "Leiderdorp",
        "BGTcode": "G0547"
    },
    {
        "BGT": "G",
        "CBS": 553,
        "Naam": "Lisse",
        "BGTcode": "G0553"
    },
    {
        "BGT": "G",
        "CBS": 556,
        "Naam": "Maassluis",
        "BGTcode": "G0556"
    },
    {
        "BGT": "G",
        "CBS": 559,
        "Naam": "Middelharnis",
        "BGTcode": "G0559"
    },
    {
        "BGT": "G",
        "CBS": 568,
        "Naam": "Bernisse",
        "BGTcode": "G0568"
    },
    {
        "BGT": "G",
        "CBS": 569,
        "Naam": "Nieuwkoop",
        "BGTcode": "G0569"
    },
    {
        "BGT": "G",
        "CBS": 571,
        "Naam": "Nieuw-Lekkerland",
        "BGTcode": "G0571"
    },
    {
        "BGT": "G",
        "CBS": 575,
        "Naam": "Noordwijk",
        "BGTcode": "G0575"
    },
    {
        "BGT": "G",
        "CBS": 576,
        "Naam": "Noordwijkerhout",
        "BGTcode": "G0576"
    },
    {
        "BGT": "G",
        "CBS": 579,
        "Naam": "Oegstgeest",
        "BGTcode": "G0579"
    },
    {
        "BGT": "G",
        "CBS": 580,
        "Naam": "Oostflakkee",
        "BGTcode": "G0580"
    },
    {
        "BGT": "G",
        "CBS": 584,
        "Naam": "Oud-Beijerland",
        "BGTcode": "G0584"
    },
    {
        "BGT": "G",
        "CBS": 585,
        "Naam": "Binnenmaas",
        "BGTcode": "G0585"
    },
    {
        "BGT": "G",
        "CBS": 588,
        "Naam": "Korendijk",
        "BGTcode": "G0588"
    },
    {
        "BGT": "G",
        "CBS": 589,
        "Naam": "Oudewater",
        "BGTcode": "G0589"
    },
    {
        "BGT": "G",
        "CBS": 590,
        "Naam": "Papendrecht",
        "BGTcode": "G0590"
    },
    {
        "BGT": "G",
        "CBS": 597,
        "Naam": "Ridderkerk",
        "BGTcode": "G0597"
    },
    {
        "BGT": "G",
        "CBS": 599,
        "Naam": "Rotterdam",
        "BGTcode": "G0599"
    },
    {
        "BGT": "G",
        "CBS": 603,
        "Naam": "Rijswijk",
        "BGTcode": "G0603"
    },
    {
        "BGT": "G",
        "CBS": 606,
        "Naam": "Schiedam",
        "BGTcode": "G0606"
    },
    {
        "BGT": "G",
        "CBS": 608,
        "Naam": "Schoonhoven",
        "BGTcode": "G0608"
    },
    {
        "BGT": "G",
        "CBS": 610,
        "Naam": "Sliedrecht",
        "BGTcode": "G0610"
    },
    {
        "BGT": "G",
        "CBS": 611,
        "Naam": "Cromstrijen",
        "BGTcode": "G0611"
    },
    {
        "BGT": "G",
        "CBS": 612,
        "Naam": "Spijkenisse",
        "BGTcode": "G0612"
    },
    {
        "BGT": "G",
        "CBS": 613,
        "Naam": "Albrandswaard",
        "BGTcode": "G0613"
    },
    {
        "BGT": "G",
        "CBS": 614,
        "Naam": "Westvoorne",
        "BGTcode": "G0614"
    },
    {
        "BGT": "G",
        "CBS": 617,
        "Naam": "Strijen",
        "BGTcode": "G0617"
    },
    {
        "BGT": "G",
        "CBS": 620,
        "Naam": "Vianen",
        "BGTcode": "G0620"
    },
    {
        "BGT": "G",
        "CBS": 622,
        "Naam": "Vlaardingen",
        "BGTcode": "G0622"
    },
    {
        "BGT": "G",
        "CBS": 623,
        "Naam": "Vlist",
        "BGTcode": "G0623"
    },
    {
        "BGT": "G",
        "CBS": 626,
        "Naam": "Voorschoten",
        "BGTcode": "G0626"
    },
    {
        "BGT": "G",
        "CBS": 627,
        "Naam": "Waddinxveen",
        "BGTcode": "G0627"
    },
    {
        "BGT": "G",
        "CBS": 629,
        "Naam": "Wassenaar",
        "BGTcode": "G0629"
    },
    {
        "BGT": "G",
        "CBS": 632,
        "Naam": "Woerden",
        "BGTcode": "G0632"
    },
    {
        "BGT": "G",
        "CBS": 637,
        "Naam": "Zoetermeer",
        "BGTcode": "G0637"
    },
    {
        "BGT": "G",
        "CBS": 638,
        "Naam": "Zoeterwoude",
        "BGTcode": "G0638"
    },
    {
        "BGT": "G",
        "CBS": 642,
        "Naam": "Zwijndrecht",
        "BGTcode": "G0642"
    },
    {
        "BGT": "G",
        "CBS": 643,
        "Naam": "Nederlek",
        "BGTcode": "G0643"
    },
    {
        "BGT": "G",
        "CBS": 644,
        "Naam": "Ouderkerk",
        "BGTcode": "G0644"
    },
    {
        "BGT": "G",
        "CBS": 653,
        "Naam": "Gaasterlân-Sleat",
        "BGTcode": "G0653"
    },
    {
        "BGT": "G",
        "CBS": 654,
        "Naam": "Borsele",
        "BGTcode": "G0654"
    },
    {
        "BGT": "G",
        "CBS": 664,
        "Naam": "Goes",
        "BGTcode": "G0664"
    },
    {
        "BGT": "G",
        "CBS": 668,
        "Naam": "West Maas en Waal",
        "BGTcode": "G0668"
    },
    {
        "BGT": "G",
        "CBS": 677,
        "Naam": "Hulst",
        "BGTcode": "G0677"
    },
    {
        "BGT": "G",
        "CBS": 678,
        "Naam": "Kapelle",
        "BGTcode": "G0678"
    },
    {
        "BGT": "G",
        "CBS": 687,
        "Naam": "Middelburg",
        "BGTcode": "G0687"
    },
    {
        "BGT": "G",
        "CBS": 689,
        "Naam": "Giessenlanden",
        "BGTcode": "G0689"
    },
    {
        "BGT": "G",
        "CBS": 693,
        "Naam": "Graafstroom",
        "BGTcode": "G0693"
    },
    {
        "BGT": "G",
        "CBS": 694,
        "Naam": "Liesveld",
        "BGTcode": "G0694"
    },
    {
        "BGT": "G",
        "CBS": 703,
        "Naam": "Reimerswaal",
        "BGTcode": "G0703"
    },
    {
        "BGT": "G",
        "CBS": 707,
        "Naam": "Zederik",
        "BGTcode": "G0707"
    },
    {
        "BGT": "G",
        "CBS": 715,
        "Naam": "Terneuzen",
        "BGTcode": "G0715"
    },
    {
        "BGT": "G",
        "CBS": 716,
        "Naam": "Tholen",
        "BGTcode": "G0716"
    },
    {
        "BGT": "G",
        "CBS": 717,
        "Naam": "Veere",
        "BGTcode": "G0717"
    },
    {
        "BGT": "G",
        "CBS": 718,
        "Naam": "Vlissingen",
        "BGTcode": "G0718"
    },
    {
        "BGT": "G",
        "CBS": 733,
        "Naam": "Lingewaal",
        "BGTcode": "G0733"
    },
    {
        "BGT": "G",
        "CBS": 736,
        "Naam": "De Ronde Venen",
        "BGTcode": "G0736"
    },
    {
        "BGT": "G",
        "CBS": 737,
        "Naam": "Tytsjerksteradiel",
        "BGTcode": "G0737"
    },
    {
        "BGT": "G",
        "CBS": 738,
        "Naam": "Aalburg",
        "BGTcode": "G0738"
    },
    {
        "BGT": "G",
        "CBS": 743,
        "Naam": "Asten",
        "BGTcode": "G0743"
    },
    {
        "BGT": "G",
        "CBS": 744,
        "Naam": "Baarle-Nassau",
        "BGTcode": "G0744"
    },
    {
        "BGT": "G",
        "CBS": 748,
        "Naam": "Bergen op Zoom",
        "BGTcode": "G0748"
    },
    {
        "BGT": "G",
        "CBS": 753,
        "Naam": "Best",
        "BGTcode": "G0753"
    },
    {
        "BGT": "G",
        "CBS": 755,
        "Naam": "Boekel",
        "BGTcode": "G0755"
    },
    {
        "BGT": "G",
        "CBS": 756,
        "Naam": "Boxmeer",
        "BGTcode": "G0756"
    },
    {
        "BGT": "G",
        "CBS": 757,
        "Naam": "Boxtel",
        "BGTcode": "G0757"
    },
    {
        "BGT": "G",
        "CBS": 758,
        "Naam": "Breda",
        "BGTcode": "G0758"
    },
    {
        "BGT": "G",
        "CBS": 762,
        "Naam": "Deurne",
        "BGTcode": "G0762"
    },
    {
        "BGT": "G",
        "CBS": 765,
        "Naam": "Pekela",
        "BGTcode": "G0765"
    },
    {
        "BGT": "G",
        "CBS": 766,
        "Naam": "Dongen",
        "BGTcode": "G0766"
    },
    {
        "BGT": "G",
        "CBS": 770,
        "Naam": "Eersel",
        "BGTcode": "G0770"
    },
    {
        "BGT": "G",
        "CBS": 772,
        "Naam": "Eindhoven",
        "BGTcode": "G0772"
    },
    {
        "BGT": "G",
        "CBS": 777,
        "Naam": "Etten-Leur",
        "BGTcode": "G0777"
    },
    {
        "BGT": "G",
        "CBS": 779,
        "Naam": "Geertruidenberg",
        "BGTcode": "G0779"
    },
    {
        "BGT": "G",
        "CBS": 784,
        "Naam": "Gilze en Rijen",
        "BGTcode": "G0784"
    },
    {
        "BGT": "G",
        "CBS": 785,
        "Naam": "Goirle",
        "BGTcode": "G0785"
    },
    {
        "BGT": "G",
        "CBS": 786,
        "Naam": "Grave",
        "BGTcode": "G0786"
    },
    {
        "BGT": "G",
        "CBS": 788,
        "Naam": "Haaren",
        "BGTcode": "G0788"
    },
    {
        "BGT": "G",
        "CBS": 794,
        "Naam": "Helmond",
        "BGTcode": "G0794"
    },
    {
        "BGT": "G",
        "CBS": 796,
        "Naam": "'s-Hertogenbosch",
        "BGTcode": "G0796"
    },
    {
        "BGT": "G",
        "CBS": 797,
        "Naam": "Heusden",
        "BGTcode": "G0797"
    },
    {
        "BGT": "G",
        "CBS": 798,
        "Naam": "Hilvarenbeek",
        "BGTcode": "G0798"
    },
    {
        "BGT": "G",
        "CBS": 809,
        "Naam": "Loon op Zand",
        "BGTcode": "G0809"
    },
    {
        "BGT": "G",
        "CBS": 815,
        "Naam": "Mill en Sint Hubert",
        "BGTcode": "G0815"
    },
    {
        "BGT": "G",
        "CBS": 820,
        "Naam": "Nuenen, Gerwen en Nederwetten",
        "BGTcode": "G0820"
    },
    {
        "BGT": "G",
        "CBS": 823,
        "Naam": "Oirschot",
        "BGTcode": "G0823"
    },
    {
        "BGT": "G",
        "CBS": 824,
        "Naam": "Oisterwijk",
        "BGTcode": "G0824"
    },
    {
        "BGT": "G",
        "CBS": 826,
        "Naam": "Oosterhout",
        "BGTcode": "G0826"
    },
    {
        "BGT": "G",
        "CBS": 828,
        "Naam": "Oss",
        "BGTcode": "G0828"
    },
    {
        "BGT": "G",
        "CBS": 840,
        "Naam": "Rucphen",
        "BGTcode": "G0840"
    },
    {
        "BGT": "G",
        "CBS": 844,
        "Naam": "Schijndel",
        "BGTcode": "G0844"
    },
    {
        "BGT": "G",
        "CBS": 845,
        "Naam": "Sint-Michielsgestel",
        "BGTcode": "G0845"
    },
    {
        "BGT": "G",
        "CBS": 846,
        "Naam": "Sint-Oedenrode",
        "BGTcode": "G0846"
    },
    {
        "BGT": "G",
        "CBS": 847,
        "Naam": "Someren",
        "BGTcode": "G0847"
    },
    {
        "BGT": "G",
        "CBS": 848,
        "Naam": "Son en Breugel",
        "BGTcode": "G0848"
    },
    {
        "BGT": "G",
        "CBS": 851,
        "Naam": "Steenbergen",
        "BGTcode": "G0851"
    },
    {
        "BGT": "G",
        "CBS": 852,
        "Naam": "Waterland",
        "BGTcode": "G0852"
    },
    {
        "BGT": "G",
        "CBS": 855,
        "Naam": "Tilburg",
        "BGTcode": "G0855"
    },
    {
        "BGT": "G",
        "CBS": 856,
        "Naam": "Uden",
        "BGTcode": "G0856"
    },
    {
        "BGT": "G",
        "CBS": 858,
        "Naam": "Valkenswaard",
        "BGTcode": "G0858"
    },
    {
        "BGT": "G",
        "CBS": 860,
        "Naam": "Veghel",
        "BGTcode": "G0860"
    },
    {
        "BGT": "G",
        "CBS": 861,
        "Naam": "Veldhoven",
        "BGTcode": "G0861"
    },
    {
        "BGT": "G",
        "CBS": 865,
        "Naam": "Vught",
        "BGTcode": "G0865"
    },
    {
        "BGT": "G",
        "CBS": 866,
        "Naam": "Waalre",
        "BGTcode": "G0866"
    },
    {
        "BGT": "G",
        "CBS": 867,
        "Naam": "Waalwijk",
        "BGTcode": "G0867"
    },
    {
        "BGT": "G",
        "CBS": 870,
        "Naam": "Werkendam",
        "BGTcode": "G0870"
    },
    {
        "BGT": "G",
        "CBS": 873,
        "Naam": "Woensdrecht",
        "BGTcode": "G0873"
    },
    {
        "BGT": "G",
        "CBS": 874,
        "Naam": "Woudrichem",
        "BGTcode": "G0874"
    },
    {
        "BGT": "G",
        "CBS": 879,
        "Naam": "Zundert",
        "BGTcode": "G0879"
    },
    {
        "BGT": "G",
        "CBS": 880,
        "Naam": "Wormerland",
        "BGTcode": "G0880"
    },
    {
        "BGT": "G",
        "CBS": 881,
        "Naam": "Onderbanken",
        "BGTcode": "G0881"
    },
    {
        "BGT": "G",
        "CBS": 882,
        "Naam": "Landgraaf",
        "BGTcode": "G0882"
    },
    {
        "BGT": "G",
        "CBS": 888,
        "Naam": "Beek",
        "BGTcode": "G0888"
    },
    {
        "BGT": "G",
        "CBS": 889,
        "Naam": "Beesel",
        "BGTcode": "G0889"
    },
    {
        "BGT": "G",
        "CBS": 893,
        "Naam": "Bergen (L.)",
        "BGTcode": "G0893"
    },
    {
        "BGT": "G",
        "CBS": 899,
        "Naam": "Brunssum",
        "BGTcode": "G0899"
    },
    {
        "BGT": "G",
        "CBS": 907,
        "Naam": "Gennep",
        "BGTcode": "G0907"
    },
    {
        "BGT": "G",
        "CBS": 917,
        "Naam": "Heerlen",
        "BGTcode": "G0917"
    },
    {
        "BGT": "G",
        "CBS": 928,
        "Naam": "Kerkrade",
        "BGTcode": "G0928"
    },
    {
        "BGT": "G",
        "CBS": 935,
        "Naam": "Maastricht",
        "BGTcode": "G0935"
    },
    {
        "BGT": "G",
        "CBS": 938,
        "Naam": "Meerssen",
        "BGTcode": "G0938"
    },
    {
        "BGT": "G",
        "CBS": 944,
        "Naam": "Mook en Middelaar",
        "BGTcode": "G0944"
    },
    {
        "BGT": "G",
        "CBS": 946,
        "Naam": "Nederweert",
        "BGTcode": "G0946"
    },
    {
        "BGT": "G",
        "CBS": 951,
        "Naam": "Nuth",
        "BGTcode": "G0951"
    },
    {
        "BGT": "G",
        "CBS": 957,
        "Naam": "Roermond",
        "BGTcode": "G0957"
    },
    {
        "BGT": "G",
        "CBS": 962,
        "Naam": "Schinnen",
        "BGTcode": "G0962"
    },
    {
        "BGT": "G",
        "CBS": 965,
        "Naam": "Simpelveld",
        "BGTcode": "G0965"
    },
    {
        "BGT": "G",
        "CBS": 971,
        "Naam": "Stein",
        "BGTcode": "G0971"
    },
    {
        "BGT": "G",
        "CBS": 981,
        "Naam": "Vaals",
        "BGTcode": "G0981"
    },
    {
        "BGT": "G",
        "CBS": 983,
        "Naam": "Venlo",
        "BGTcode": "G0983"
    },
    {
        "BGT": "G",
        "CBS": 984,
        "Naam": "Venray",
        "BGTcode": "G0984"
    },
    {
        "BGT": "G",
        "CBS": 986,
        "Naam": "Voerendaal",
        "BGTcode": "G0986"
    },
    {
        "BGT": "G",
        "CBS": 988,
        "Naam": "Weert",
        "BGTcode": "G0988"
    },
    {
        "BGT": "G",
        "CBS": 994,
        "Naam": "Valkenburg aan de Geul",
        "BGTcode": "G0994"
    },
    {
        "BGT": "G",
        "CBS": 995,
        "Naam": "Lelystad",
        "BGTcode": "G0995"
    },
    {
        "BGT": "G",
        "CBS": 1507,
        "Naam": "Horst aan de Maas",
        "BGTcode": "G1507"
    },
    {
        "BGT": "G",
        "CBS": 1509,
        "Naam": "Oude IJsselstreek",
        "BGTcode": "G1509"
    },
    {
        "BGT": "G",
        "CBS": 1525,
        "Naam": "Teylingen",
        "BGTcode": "G1525"
    },
    {
        "BGT": "G",
        "CBS": 1581,
        "Naam": "Utrechtse Heuvelrug",
        "BGTcode": "G1581"
    },
    {
        "BGT": "G",
        "CBS": 1586,
        "Naam": "Oost Gelre",
        "BGTcode": "G1586"
    },
    {
        "BGT": "G",
        "CBS": 1598,
        "Naam": "Koggenland",
        "BGTcode": "G1598"
    },
    {
        "BGT": "G",
        "CBS": 1621,
        "Naam": "Lansingerland",
        "BGTcode": "G1621"
    },
    {
        "BGT": "G",
        "CBS": 1640,
        "Naam": "Leudal",
        "BGTcode": "G1640"
    },
    {
        "BGT": "G",
        "CBS": 1641,
        "Naam": "Maasgouw",
        "BGTcode": "G1641"
    },
    {
        "BGT": "G",
        "CBS": 1651,
        "Naam": "Eemsmond",
        "BGTcode": "G1651"
    },
    {
        "BGT": "G",
        "CBS": 1652,
        "Naam": "Gemert-Bakel",
        "BGTcode": "G1652"
    },
    {
        "BGT": "G",
        "CBS": 1655,
        "Naam": "Halderberge",
        "BGTcode": "G1655"
    },
    {
        "BGT": "G",
        "CBS": 1658,
        "Naam": "Heeze-Leende",
        "BGTcode": "G1658"
    },
    {
        "BGT": "G",
        "CBS": 1659,
        "Naam": "Laarbeek",
        "BGTcode": "G1659"
    },
    {
        "BGT": "G",
        "CBS": 1663,
        "Naam": "De Marne",
        "BGTcode": "G1663"
    },
    {
        "BGT": "G",
        "CBS": 1667,
        "Naam": "Reusel-De Mierden",
        "BGTcode": "G1667"
    },
    {
        "BGT": "G",
        "CBS": 1669,
        "Naam": "Roerdalen",
        "BGTcode": "G1669"
    },
    {
        "BGT": "G",
        "CBS": 1671,
        "Naam": "Maasdonk",
        "BGTcode": "G1671"
    },
    {
        "BGT": "G",
        "CBS": 1672,
        "Naam": "Rijnwoude",
        "BGTcode": "G1672"
    },
    {
        "BGT": "G",
        "CBS": 1674,
        "Naam": "Roosendaal",
        "BGTcode": "G1674"
    },
    {
        "BGT": "G",
        "CBS": 1676,
        "Naam": "Schouwen-Duiveland",
        "BGTcode": "G1676"
    },
    {
        "BGT": "G",
        "CBS": 1680,
        "Naam": "Aa en Hunze",
        "BGTcode": "G1680"
    },
    {
        "BGT": "G",
        "CBS": 1681,
        "Naam": "Borger-Odoorn",
        "BGTcode": "G1681"
    },
    {
        "BGT": "G",
        "CBS": 1684,
        "Naam": "Cuijk",
        "BGTcode": "G1684"
    },
    {
        "BGT": "G",
        "CBS": 1685,
        "Naam": "Landerd",
        "BGTcode": "G1685"
    },
    {
        "BGT": "G",
        "CBS": 1690,
        "Naam": "De Wolden",
        "BGTcode": "G1690"
    },
    {
        "BGT": "G",
        "CBS": 1695,
        "Naam": "Noord-Beveland",
        "BGTcode": "G1695"
    },
    {
        "BGT": "G",
        "CBS": 1696,
        "Naam": "Wijdemeren",
        "BGTcode": "G1696"
    },
    {
        "BGT": "G",
        "CBS": 1699,
        "Naam": "Noordenveld",
        "BGTcode": "G1699"
    },
    {
        "BGT": "G",
        "CBS": 1700,
        "Naam": "Twenterand",
        "BGTcode": "G1700"
    },
    {
        "BGT": "G",
        "CBS": 1701,
        "Naam": "Westerveld",
        "BGTcode": "G1701"
    },
    {
        "BGT": "G",
        "CBS": 1702,
        "Naam": "Sint Anthonis",
        "BGTcode": "G1702"
    },
    {
        "BGT": "G",
        "CBS": 1705,
        "Naam": "Lingewaard",
        "BGTcode": "G1705"
    },
    {
        "BGT": "G",
        "CBS": 1706,
        "Naam": "Cranendonck",
        "BGTcode": "G1706"
    },
    {
        "BGT": "G",
        "CBS": 1708,
        "Naam": "Steenwijkerland",
        "BGTcode": "G1708"
    },
    {
        "BGT": "G",
        "CBS": 1709,
        "Naam": "Moerdijk",
        "BGTcode": "G1709"
    },
    {
        "BGT": "G",
        "CBS": 1711,
        "Naam": "Echt-Susteren",
        "BGTcode": "G1711"
    },
    {
        "BGT": "G",
        "CBS": 1714,
        "Naam": "Sluis",
        "BGTcode": "G1714"
    },
    {
        "BGT": "G",
        "CBS": 1719,
        "Naam": "Drimmelen",
        "BGTcode": "G1719"
    },
    {
        "BGT": "G",
        "CBS": 1721,
        "Naam": "Bernheze",
        "BGTcode": "G1721"
    },
    {
        "BGT": "G",
        "CBS": 1722,
        "Naam": "Ferwerderadiel",
        "BGTcode": "G1722"
    },
    {
        "BGT": "G",
        "CBS": 1723,
        "Naam": "Alphen-Chaam",
        "BGTcode": "G1723"
    },
    {
        "BGT": "G",
        "CBS": 1724,
        "Naam": "Bergeijk",
        "BGTcode": "G1724"
    },
    {
        "BGT": "G",
        "CBS": 1728,
        "Naam": "Bladel",
        "BGTcode": "G1728"
    },
    {
        "BGT": "G",
        "CBS": 1729,
        "Naam": "Gulpen-Wittem",
        "BGTcode": "G1729"
    },
    {
        "BGT": "G",
        "CBS": 1730,
        "Naam": "Tynaarlo",
        "BGTcode": "G1730"
    },
    {
        "BGT": "G",
        "CBS": 1731,
        "Naam": "Midden-Drenthe",
        "BGTcode": "G1731"
    },
    {
        "BGT": "G",
        "CBS": 1734,
        "Naam": "Overbetuwe",
        "BGTcode": "G1734"
    },
    {
        "BGT": "G",
        "CBS": 1735,
        "Naam": "Hof van Twente",
        "BGTcode": "G1735"
    },
    {
        "BGT": "G",
        "CBS": 1740,
        "Naam": "Neder-Betuwe",
        "BGTcode": "G1740"
    },
    {
        "BGT": "G",
        "CBS": 1742,
        "Naam": "Rijssen-Holten",
        "BGTcode": "G1742"
    },
    {
        "BGT": "G",
        "CBS": 1771,
        "Naam": "Geldrop-Mierlo",
        "BGTcode": "G1771"
    },
    {
        "BGT": "G",
        "CBS": 1773,
        "Naam": "Olst-Wijhe",
        "BGTcode": "G1773"
    },
    {
        "BGT": "G",
        "CBS": 1774,
        "Naam": "Dinkelland",
        "BGTcode": "G1774"
    },
    {
        "BGT": "G",
        "CBS": 1783,
        "Naam": "Westland",
        "BGTcode": "G1783"
    },
    {
        "BGT": "G",
        "CBS": 1842,
        "Naam": "Midden-Delfland",
        "BGTcode": "G1842"
    },
    {
        "BGT": "G",
        "CBS": 1859,
        "Naam": "Berkelland",
        "BGTcode": "G1859"
    },
    {
        "BGT": "G",
        "CBS": 1876,
        "Naam": "Bronckhorst",
        "BGTcode": "G1876"
    },
    {
        "BGT": "G",
        "CBS": 1883,
        "Naam": "Sittard-Geleen",
        "BGTcode": "G1883"
    },
    {
        "BGT": "G",
        "CBS": 1884,
        "Naam": "Kaag en Braassem",
        "BGTcode": "G1884"
    },
    {
        "BGT": "G",
        "CBS": 1891,
        "Naam": "Dantumadiel",
        "BGTcode": "G1891"
    },
    {
        "BGT": "G",
        "CBS": 1892,
        "Naam": "Zuidplas",
        "BGTcode": "G1892"
    },
    {
        "BGT": "G",
        "CBS": 1894,
        "Naam": "Peel en Maas",
        "BGTcode": "G1894"
    },
    {
        "BGT": "G",
        "CBS": 1895,
        "Naam": "Oldambt",
        "BGTcode": "G1895"
    },
    {
        "BGT": "G",
        "CBS": 1896,
        "Naam": "Zwartewaterland",
        "BGTcode": "G1896"
    },
    {
        "BGT": "G",
        "CBS": 1900,
        "Naam": "Súdwest Fryslân",
        "BGTcode": "G1900"
    },
    {
        "BGT": "G",
        "CBS": 1901,
        "Naam": "Bodegraven-Reeuwijk",
        "BGTcode": "G1901"
    },
    {
        "BGT": "G",
        "CBS": 1903,
        "Naam": "Eijsden-Margraten",
        "BGTcode": "G1903"
    },
    {
        "BGT": "G",
        "CBS": 1904,
        "Naam": "Stichtse Vecht",
        "BGTcode": "G1904"
    },
    {
        "BGT": "G",
        "CBS": 1908,
        "Naam": "Menameradiel",
        "BGTcode": "G1908"
    },
    {
        "BGT": "G",
        "CBS": 1911,
        "Naam": "Hollands Kroon",
        "BGTcode": "G1911"
    },
    {
        "BGT": "G",
        "CBS": 1916,
        "Naam": "Leidschendam-Voorburg",
        "BGTcode": "G1916"
    },
    {
        "BGT": "G",
        "CBS": 1921,
        "Naam": "De Friese Meren",
        "BGTcode": "G1921"
    },
    {
        "BGT": "G",
        "CBS": 1926,
        "Naam": "Pijnacker-Nootdorp",
        "BGTcode": "G1926"
    },
    {
        "BGT": "G",
        "CBS": 1955,
        "Naam": "Montferland",
        "BGTcode": "G1955"
    },
    {
        "BGT": "G",
        "CBS": 1987,
        "Naam": "Menterwolde",
        "BGTcode": "G1987"
    },
    {
        "BGT": "G",
        "CBS": 1930,
        "Naam": "Nissewaard",
        "BGTcode": "G1930"
    },
    {
        "BGT": "G",
        "CBS": 1931,
        "Naam": "Krimpenerwaard",
        "BGTcode": "G1931"
    },
    {
        "BGT": "G ",
        "CBS": 1940,
        "Naam": "De Fryske Marren",
        "BGTcode": "G1940"
    },
    {
        "BGT": "G",
        "CBS": 1942,
        "Naam": "Gooise Meren",
        "BGTcode": "G1942"
    },
    {
        "BGT": "G",
        "CBS": 1945,
        "Naam": "Berg en Dal",
        "BGTcode": "G1945"
    },
    {
        "BGT": "G",
        "CBS": 1948,
        "Naam": "Meierijstad",
        "BGTcode": "G1948"
    },
    {
        "BGT": "G",
        "CBS": 1949,
        "Naam": "Waadhoeke",
        "BGTcode": "G1949"
    },
    {
        "BGT": "G",
        "CBS": 1950,
        "Naam": "Westerwolde",
        "BGTcode": "G1950"
    },
    {
        "BGT": "G",
        "CBS": 1952,
        "Naam": "Midden-Groningen",
        "BGTcode": "G1952"
    },
    {
        "BGT": "G",
        "CBS": 1954,
        "Naam": "Beekdaelen",
        "BGTcode": "G1954"
    },
    {
        "BGT": "G",
        "CBS": 1959,
        "Naam": "Altena",
        "BGTcode": "G1959"
    },
    {
        "BGT": "G",
        "CBS": 1960,
        "Naam": "West Betuwe",
        "BGTcode": "G1960"
    },
    {
        "BGT": "G",
        "CBS": 1961,
        "Naam": "Vijfheerenlanden",
        "BGTcode": "G1961"
    },
    {
        "BGT": "G",
        "CBS": 1963,
        "Naam": "Hoeksche Waard",
        "BGTcode": "G1963"
    },
    {
        "BGT": "G",
        "CBS": 1966,
        "Naam": "Het Hogeland",
        "BGTcode": "G1966"
    },
    {
        "BGT": "G",
        "CBS": 1969,
        "Naam": "Westerkwartier",
        "BGTcode": "G1969"
    },
    {
        "BGT": "G",
        "CBS": 1970,
        "Naam": "Noardeast-Fryslân",
        "BGTcode": "G1970"
    },
    {
        "BGT": "G",
        "CBS": 1978,
        "Naam": "Molenlanden",
        "BGTcode": "G1978"
    },
    {
        "BGT": "P00",
        "CBS": 20,
        "Naam": "Groningen",
        "BGTcode": "P0020"
    },
    {
        "BGT": "P00",
        "CBS": 21,
        "Naam": "Friesland",
        "BGTcode": "P0021"
    },
    {
        "BGT": "P00",
        "CBS": 22,
        "Naam": "Drenthe",
        "BGTcode": "P0022"
    },
    {
        "BGT": "P00",
        "CBS": 23,
        "Naam": "Overijssel",
        "BGTcode": "P0023"
    },
    {
        "BGT": "P00",
        "CBS": 24,
        "Naam": "Flevoland",
        "BGTcode": "P0024"
    },
    {
        "BGT": "P00",
        "CBS": 25,
        "Naam": "Gelderland",
        "BGTcode": "P0025"
    },
    {
        "BGT": "P00",
        "CBS": 26,
        "Naam": "Utrecht",
        "BGTcode": "P0026"
    },
    {
        "BGT": "P00",
        "CBS": 27,
        "Naam": "Noord-Holland",
        "BGTcode": "P0027"
    },
    {
        "BGT": "P00",
        "CBS": 28,
        "Naam": "Zuid-Holland",
        "BGTcode": "P0028"
    },
    {
        "BGT": "P00",
        "CBS": 29,
        "Naam": "Zeeland",
        "BGTcode": "P0029"
    },
    {
        "BGT": "P00",
        "CBS": 30,
        "Naam": "Noord-Brabant",
        "BGTcode": "P0030"
    },
    {
        "BGT": "P00",
        "CBS": 31,
        "Naam": "Limburg",
        "BGTcode": "P0031"
    },
    {
        "BGT": "W",
        "CBS": 151,
        "Naam": "Waterschap Groot Salland",
        "BGTcode": "W0151"
    },
    {
        "BGT": "W",
        "CBS": 152,
        "Naam": "Waterschap Rijn en IJssel",
        "BGTcode": "W0152"
    },
    {
        "BGT": "W",
        "CBS": 153,
        "Naam": "Waterschap Veluwe",
        "BGTcode": "W0153"
    },
    {
        "BGT": "W",
        "CBS": 154,
        "Naam": "Waterschap Vallei & Eem",
        "BGTcode": "W0154"
    },
    {
        "BGT": "W",
        "CBS": 155,
        "Naam": "Hoogheemraadschap Amstel, Gooi en Vecht",
        "BGTcode": "W0155"
    },
    {
        "BGT": "W",
        "CBS": 201,
        "Naam": "Waterschap Regge en Dinkel",
        "BGTcode": "W0201"
    },
    {
        "BGT": "W",
        "CBS": 372,
        "Naam": "Hoogheemraadschap van Delfland",
        "BGTcode": "W0372"
    },
    {
        "BGT": "W",
        "CBS": 524,
        "Naam": "Waterschap Zeeuwse Eilanden",
        "BGTcode": "W0524"
    },
    {
        "BGT": "W",
        "CBS": 524,
        "Naam": "Waterschap Zeeuws-Vlaanderen",
        "BGTcode": "W0524"
    },
    {
        "BGT": "W",
        "CBS": 539,
        "Naam": "Waterschap De Dommel",
        "BGTcode": "W0539"
    },
    {
        "BGT": "W",
        "CBS": 585,
        "Naam": "Waterschap Roer en Overmaas",
        "BGTcode": "W0585"
    },
    {
        "BGT": "W",
        "CBS": 621,
        "Naam": "Waterschap Rivierenland",
        "BGTcode": "W0621"
    },
    {
        "BGT": "W",
        "CBS": 616,
        "Naam": "Hoogheemraadschap van Rijnland",
        "BGTcode": "W0616"
    },
    {
        "BGT": "W",
        "CBS": 636,
        "Naam": "Hoogheemraadschap De Stichtse Rijnlanden",
        "BGTcode": "W0636"
    },
    {
        "BGT": "W",
        "CBS": 638,
        "Naam": "Waterschap Peel en Maasvallei",
        "BGTcode": "W0638"
    },
    {
        "BGT": "W",
        "CBS": 646,
        "Naam": "Waterschap Hunze en Aa's",
        "BGTcode": "W0646"
    },
    {
        "BGT": "W",
        "CBS": 647,
        "Naam": "Waterschap Noorderzijlvest",
        "BGTcode": "W0647"
    },
    {
        "BGT": "W",
        "CBS": 648,
        "Naam": "Waterschap Reest en Wieden",
        "BGTcode": "W0648"
    },
    {
        "BGT": "W",
        "CBS": 649,
        "Naam": "Waterschap Velt en Vecht",
        "BGTcode": "W0649"
    },
    {
        "BGT": "W",
        "CBS": 650,
        "Naam": "Waterschap Zuiderzeeland",
        "BGTcode": "W0650"
    },
    {
        "BGT": "W",
        "CBS": 651,
        "Naam": "Hoogheemraadschap Hollands Noorderkwartier",
        "BGTcode": "W0651"
    },
    {
        "BGT": "W",
        "CBS": 652,
        "Naam": "Waterschap Brabantse Delta",
        "BGTcode": "W0652"
    },
    {
        "BGT": "W",
        "CBS": 653,
        "Naam": "Wetterskip Fryslân",
        "BGTcode": "W0653"
    },
    {
        "BGT": "W",
        "CBS": 654,
        "Naam": "Waterschap Aa en Maas",
        "BGTcode": "W0654"
    },
    {
        "BGT": "W",
        "CBS": 655,
        "Naam": "Waterschap Hollandse Delta",
        "BGTcode": "W0655"
    },
    {
        "BGT": "W",
        "CBS": 656,
        "Naam": "Hoogheemraadschap van Schieland en de Krimpenerwaard",
        "BGTcode": "W0656"
    },
    {
        "BGT": "W",
        "CBS": 659,
        "Naam": "Waterschapsbedrijf Limburg",
        "BGTcode": "W0659"
    },
    {
        "BGT": "W",
        "CBS": 661,
        "Naam": "Waterschap Scheldestromen",
        "BGTcode": "W0661"
    },
    {
        "BGT": "W",
        "CBS": 662,
        "Naam": "Waterschap Vallei en Veluwe",
        "BGTcode": "W0662"
    },
    {
        "BGT": "W",
        "CBS": 663,
        "Naam": "Waterschap Vechtstromen",
        "BGTcode": "W0663"
    },
    {
        "BGT": "W",
        "CBS": 664,
        "Naam": "Waterschap Drents Overijsselse Delta",
        "BGTcode": "W0664"
    },
    {
        "BGT": "W",
        "CBS": 665,
        "Naam": "Waterschap Limburg",
        "BGTcode": "W0665"
    },
    {
        "BGT": "L0001",
        "Naam": "Economische Zaken (EZ)",
        "BGTcode": "L0001"
    },
    {
        "BGT": "L0002",
        "Naam": "Ministerie Infrastructuur en Milieu (RWS) ",
        "BGTcode": "L0002"
    },
    {
        "BGT": "L0003",
        "Naam": "Ministerie van Defensie",
        "BGTcode": "L0003"
    },
    {
        "BGT": "L0004",
        "Naam": "Prorail",
        "BGTcode": "L0004"
    },
    {
        "BGT": "K0001",
        "Naam": "Kadaster",
        "BGTcode": "K0001"
    },
    {
        "BGT": "S0001",
        "Naam": "Samenwerkingsverband voor Bronhouders",
        "BGTcode": "S0001"
    }
]